<template>
  <div class="container">
    <header>
      <div class="left">
        <img src="@/assets/new/lists.png" alt="" @click="show = true" />
        <span @click="show = true">{{ showProductName() }}/USDT</span>
      </div>
      <div class="right">
        <img
          src="@/assets/new/contract.png"
          alt=""
          v-if="productNowInfo[activeIndex].IsContract"
          @click="goContract"
        />
        <img
          src="@/assets/new/trade1.png"
          alt=""
          v-if="productNowInfo[activeIndex].IsCoin"
          @click="goCoin"
        />
      </div>
    </header>
    <div class="info">
      <div
        class="left down"
        :style="{
          color:
            productNowInfo[activeIndex].BasicPrice -
              productNowInfo[activeIndex].Price >
            0
              ? basicConfig.FallColour
              : basicConfig.RiseColour
        }"
      >
        <div class="price">
          {{ productNowInfo[activeIndex].Price }}
        </div>
        <div class="radio">{{ getRole() }}%</div>
      </div>
      <div class="right">
        <div>
          <span>{{ $t('contract').gao }}</span
          ><span>{{ productNowInfo[activeIndex].High }}</span>
        </div>
        <div>
          <span>{{ $t('contract').di }}</span
          ><span>{{ productNowInfo[activeIndex].Low }}</span>
        </div>
        <div>
          <span>{{ $t('contract').liang }}</span
          ><span>{{ productNowInfo[activeIndex].Amount }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="data-mode-box">
      <div
        v-for="(dItem, dIndex) in dataModeList"
        :key="dIndex"
        :class="{ dataMoeActive: dataMoeActiveIndex === dIndex }"
        @click="changedataMode(dIndex)"
      >
        {{ dItem }}
      </div>
    </div> -->
    <div class="echar-box">
      <!-- <div class="now-data" v-if="dataMoeActiveIndex !== 0 && Kdata.length > 0">
        <div class="item">O： {{ lastPrice.Open }}</div>
        <div class="item">H： {{ lastPrice.High }}</div>
        <div class="item">L： {{ lastPrice.Low }}</div>
        <div class="item">C： {{ lastPrice.Close }}</div>
      </div>
      <div class="echars" v-show="dataMoeActiveIndex === 0">
        <EcharI :width="width" :height="height" :Ldata="Ldata" :split="split" />
      </div>
      <div class="echars" v-show="dataMoeActiveIndex !== 0">
        <EcharK
          :dayMode="dataMoeActiveIndex === 5 ? true : false"
          :width="width"
          :Kdata="Kdata"
          :height="height"
          id="b"
        />
      </div> -->
      <TradingView :TvCode="select_tv_code" Height="340px" ref="tra"></TradingView>
    </div>
    <List ref="orderList" :productInfo="productNowInfo[activeIndex]" />
    <Buy :buyModeList="buyModeList" :ProductInfo="ProductInfo" />
    <TabBar :active="active" />
    <van-popup
      v-model="show"
      position="left"
      :style="{ width: '244px', height: 'calc(100vh - 100px )' }"
    >
      <PopupInfo :productNowInfo="productNowInfo" @change="changeProduct" />
    </van-popup>
  </div>
</template>

<script>
// import EcharK from '@/components/echarK'
// import EcharI from '@/components/echarI'
import productApi from '@/api/product'
import List from './components/list'
import Buy from './components/buy'
import PopupInfo from './components/popupInfo'
import TabBar from '@/components/tabBarNew'
import { mapGetters } from 'vuex'
import formate from '@/mixins'
import TradingView from "@/components/TradingView"
export default {
  mixins: [formate],
  components: {
    List,
    TabBar,
    Buy,
    PopupInfo,
    TradingView
    // EcharK,
    // EcharI
  },
  data() {
    return {
      select_tv_code:'',
      dataMoeActiveIndex: 2,
      Kdata: [],
      activeIndex: 0,
      show: false,
      dataModeList: [],
      active: 'Product',
      ProductInfo: {},
      width: '100vw',
      height: '67vw',
      lastPrice: null,
      Ldata: [],
      ProductId: null,
      split: [],
      buyModeList: [{ Id: 0, Time: 0, Win: 0, Lose: 0 }],
      productList: [],
      productNowInfo: [
        {
          BasicPrice: 0,
          Price: 0,
          High: 0,
          Low: 0,
          Amount: 0
        }
      ]
    }
  },
  computed: {
    lang() {
      this.change()
      return this.$store.getters.lang
    },
    ...mapGetters(['connection', 'basicConfig'])
  },
  mounted() {
    this.firstEnter = false
    this.change()
    this.getList()
    this.signalRStart()
  },
  destroyed() {
    if (this.connection.connectionState === 'Connected') {
      this.connection.off('product')
      this.connection.invoke('SendMsg', '')
    }
  },
  methods: {
    goCoin() {
      sessionStorage.setItem('coin', this.productNowInfo[this.activeIndex].Id)
      this.$router.push({
        name: 'Trade'
      })
    },
    goContract() {
      sessionStorage.setItem(
        'leverage',
        this.productNowInfo[this.activeIndex].Id
      )
      this.$router.push({
        name: 'Leverage'
      })
    },
    getRole() {
      const Role = (
        ((this.productNowInfo[this.activeIndex].Price -
          this.productNowInfo[this.activeIndex].BasicPrice) /
          this.productNowInfo[this.activeIndex].Price) *
        100
      ).toFixed(2)
      return Role > 0 ? `+${Role}` : Role
    },
    showProductName() {
      let name = ''
      this.productList.forEach((item) => {
        if (item.Id === this.ProductId) {
          name = item.Name
          // if (this.lang === 'zh') {
          //   name = item.Name
          // } else if (this.lang === 'en') {
          //   name = item.EnglishName
          // } else {
          //   name = item.TraditionalName
          // }
          return
        }
      })
      return name
    },
    change() {
      let product = this.$t('contract')
      this.dataModeList = [
        product.Trend,
        '1' + product.smallMin,
        '5' + product.smallMin,
        '15' + product.smallMin,
        '1' + product.hour,
        '1' + product.dayMin
      ]
    },
    async getList() {
      this.productList = await productApi.list()
      const ProductId = this.$route.params.id
      if (ProductId) {
        this.ProductId = ProductId
        sessionStorage.setItem('product', ProductId)
      } else {
        const ProductId1 = sessionStorage.getItem('product')
        this.ProductId = ProductId1
          ? Number(ProductId1)
          : this.productList[0].Id
      }

      this.productNowInfo = this.productList
      this.firstSetTabProduct()
    },
    // 获得购买选项
    getbuyModeList(index) {
      this.ProductInfo = this.productList[index]
      this.buyModeList = this.productList[index].Proportion
      this.buyModeList.forEach((item) => {
        item.Time = this.dateFormate(item.Time)
      })
    },
    firstSetTabProduct() {
      if (this.firstEnter) {
        return
      }
      this.productList.forEach((item, index) => {
        if (item.Id === this.ProductId) {
          this.firstEnter = true
          this.activeIndex = index
          this.getbuyModeList(index)
          // this.getKData(2)
          this.select_tv_code = item.TraditionalName
          this.$refs.tra.tradingview( this.select_tv_code)
          return
        }
      })
    },
    // 选择产品
    changeProduct(index) {
      this.show = false
      this.activeIndex = index
      this.ProductId = this.productList[index].Id
      sessionStorage.setItem('product', this.ProductId)
      this.dataMoeActiveIndex = 2
      this.getbuyModeList(index)
      // this.getKData(2)
      this.select_tv_code = this.productList[index].TraditionalName
      this.$refs.tra.tradingview( this.select_tv_code)
      this.$refs.orderList.reset()
    },
    // 选择分时图，1M,3M,5M,15M
    changedataMode(index) {
      this.dataMoeActiveIndex = index
      this.getKData(index)
    },
    async getSecondData(data) {
      let productNowInfo = data
      let productList = [...this.productList]
      productNowInfo.forEach((item) => {
        productList.some((pItem) => {
          if (pItem.Id === item.ProductId) {
            pItem.Price = item.Price
            pItem.Rise = item.Rise
            pItem.High = item.High
            pItem.Low = item.Low
            pItem.Amount = item.Amount
            return true
          }
        })
      })

      this.productNowInfo = productList
      if (!this.dataMoeActiveIndex) {
        data.forEach((item) => {
          if (item.ProductId === this.ProductId) {
            this.Ldata.push(item.Price)
            this.split.push('')
            if (this.Ldata.length > 100) {
              this.Ldata.shift()
              this.split.shift()
            }
          }
        })
      }
    },
    signalRStart() {
      let that = this
      let connection = this.connection
      let time = setInterval(() => {
        if (connection.connectionState === 'Connected') {
          clearInterval(time)
          time = null
          connection.invoke('SendMsg', 'product')
        }
      }, 100)
      connection.on('secondPrices', function(res) {
        that.getSecondData(res)
      })
    },
    async getKData(mode) {
      let res = []
      switch (mode) {
        case 1:
          res = await productApi.get1M(this.ProductId)
          this.lastPrice = res[res.length - 1]
          break
        case 2:
          res = await productApi.get5M(this.ProductId)
          this.lastPrice = res[res.length - 1]
          break
        case 3:
          res = await productApi.get15M(this.ProductId)
          this.lastPrice = res[res.length - 1]
          break
        case 4:
          res = await productApi.get1Hour(this.ProductId)
          this.lastPrice = res[res.length - 1]
          break
        case 5:
          res = await productApi.getOneDay(this.ProductId)
          this.lastPrice = res[res.length - 1]
          break
        default:
          this.Ldata = []
          this.getLata()
          this.split = [...Array(100)].map(() => '')
      }
      this.Kdata = res
    },
    async getLata() {
      const result = await productApi.getOneSecondPrices(this.ProductId)
      result.forEach((item) => {
        this.Ldata.push(item.Price)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 50px 0;
  & /deep/ .van-popup--left {
    top: 0;
    height: calc(100vh - 120px) !important;
    transform: translate3d(0, 0, 0);
  }
  header {
    position: fixed;
    left: 0;
    top: 0;
    height: 50px;
    width: 100vw;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 10px;
    z-index: 99;
    background: #131f30;
    img {
      width: 20px;
      height: 20px;
      margin: 0 10px;
    }
    .left {
      display: flex;
      align-items: center;
    }
    span {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .info {
    background: #131f30;
    display: flex;
    align-items: center;
    height: 90px;
    padding: 10px 20px;
    font-size: 14px;
    .left {
      flex: 1;
      // margin-right: 70px;
      text-align: center;
      .price {
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 24px;
        line-height: 1.5;
      }
    }
    .right {
      flex: 1;
      div {
        display: flex;
        line-height: 1.6;
        justify-content: space-between;
        color: #9fbedc;
        span:nth-of-type(2) {
          color: #fff;
        }
      }
    }
  }
  .echar-box {
    position: relative;
    .now-data {
      position: absolute;
      left: 20px;
      top: 13px;
      color: #4e5b85;
      line-height: 16px;
      z-index: 10;
    }
  }
  .data-mode-box {
    display: flex;
    background: #131f30;
    height: 28px;
    margin-top: 5px;
    div {
      flex: 1;
      color: #999999;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .dataMoeActive {
      color: #f2ba18;
      border-bottom: 1px solid #f2ba18;
    }
  }
}
</style>
